import React, { useState } from 'react';
import { ReactComponent as InfoCircleFilled } from 'assets/icons/inforCircleFilled.svg';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import PropTypes from 'prop-types';

export default function Hint(props) {
  const { title, content, className } = props;
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`w-full flex flex-col rounded-[4px] border border-solid border-blue-200 bg-blue-50 ${className || ''}`}
    >
      <button
        className="bg-transparent border-none outline-none p-2 cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <div className="w-full flex flex-row items-center bg-transparent border-none">
          <InfoCircleFilled />
          <h4 className="!text-sm font-medium grow text-left !ml-2 !text-bleu-hellio-600">
            {title}
          </h4>
          <ChevronDown
            width={18}
            height={18}
            style={{ transform: `rotate(${open ? '0' : '-90'}deg)` }}
          />
        </div>
      </button>
      {open && <div className="pl-[32px] pr-2 w-full pb-4">{content}</div>}
    </div>
  );
}

Hint.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.element,
};
